<template>
  <el-dialog
    title="人工充值"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="depositForm"
      :model="form"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="会员名称：" prop="companyName">
        <el-input
          v-model="form.companyName"
          disabled
        ></el-input>
      </el-form-item>
      
      <el-form-item label="充值金额：" prop="amount">
        <el-input
          v-model="form.amount"
          placeholder="请输入充值金额"
          type="number"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="充值交易流水号：" prop="tradeNo">
        <el-input
          v-model="form.tradeNo"
          placeholder="请输入充值交易流水号"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="支付凭证：" v-if="!form.payVoucherUrl">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :show-file-list="false"
          accept=".pdf,.jpg,.png,.jpeg"
          name="fileVal"
        >
          <el-button size="small" type="primary">上传凭证</el-button>
        </el-upload>
      </el-form-item>
      
      <el-form-item label="支付凭证：" v-else>
        <div>
          <el-button size="small" @click="viewVoucher">查看</el-button>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".pdf,.jpg,.png,.jpeg"
            name="fileVal"
            style="margin-left: 10px;"
          >
            <el-button size="small" type="primary">重新上传</el-button>
          </el-upload>
        </div>
      </el-form-item>
      
      <el-form-item label="操作员：">
        <el-input
          v-model="form.operator"
          disabled
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">充 值</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { manualHyxUserDeposit, getHyxUserInfo } from '@/api/member'

export default {
  name: 'Deposit',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    // 金额验证规则
    const validateAmount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入充值金额'))
        return
      }
      
      const amount = parseFloat(value)
      if (isNaN(amount) || amount <= 0) {
        callback(new Error('请输入正确的金额'))
        return
      }
      
      callback()
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      form: {
        companyName: '',
        amount: '',
        tradeNo: '',
        payVoucherUrl: '',
        operator: ''
      },
      rules: {
        companyName: [
          { required: true, message: '会员名称不能为空', trigger: 'blur' }
        ],
        amount: [
          { required: true, validator: validateAmount, trigger: 'blur' }
        ],
        tradeNo: [
          { required: true, message: '请输入充值交易流水号', trigger: 'blur' }
        ]
      },
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.resetForm()
      
      // 获取操作员信息
      try {
        // 在实际项目中，应该调用获取当前管理员信息的接口
        this.form.operator = '管理员'
      } catch (error) {
        console.error('获取操作员信息失败:', error)
      }
      
      // 获取用户信息
      if (this.userId) {
        try {
          const res = await getHyxUserInfo({ id: this.userId })
          if (res.err_code === 0) {
            this.form.companyName = res.data.company_name
          }
        } catch (error) {
          console.error('获取用户信息失败:', error)
        }
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.depositForm && this.$refs.depositForm.resetFields()
      this.form.companyName = ''
      this.form.amount = ''
      this.form.tradeNo = ''
      this.form.payVoucherUrl = ''
      this.form.operator = ''
    },

    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        this.form.payVoucherUrl = response.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 上传失败回调
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },

    // 查看支付凭证
    viewVoucher() {
      if (this.form.payVoucherUrl) {
        window.open(this.form.payVoucherUrl, '_blank')
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.depositForm.validate(async (valid) => {
        if (valid) {
          if (!this.form.tradeNo) {
            this.$message.warning('请填写充值交易流水号')
            return
          }
          
          this.submitting = true
          try {
            const params = {
              hyx_user_id: Number(this.userId),
              amount: Math.round(this.form.amount * 100), // 转换为分
              trade_no: this.form.tradeNo,
              pay_voucher_url: this.form.payVoucherUrl
            }
            
            const res = await manualHyxUserDeposit(params)
            if (res.err_code === 0) {
              this.$message.success('保存成功')
              this.$emit('success')
              this.handleClose()
            } else if (res.err_code === 1002) {
              this.$message.error('没有操作权限')
            } else if (res.err_code === 1010) {
              this.$message.error('用户不存在')
            } else {
              this.$message.error(res.err_msg || '保存失败')
            }
          } catch (error) {
            console.error('充值失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>